import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { Screens } from './index';

import { FormLayout } from '@/components';
import { useAuth } from '@/features/auth';

export const PublicRoute = ({ element, ...rest }: any) => {
    const { isAuthenticated } = useAuth();
    return (
        <Route
            {...rest}
            element={(() => {
                if (isAuthenticated) {
                    return <Navigate to={Screens.Dashboard} />;
                }

                return <FormLayout>{element}</FormLayout>;
            })()}
        />
    );
};
